export default class ReviewItem extends HTMLElement {
    private reviewData: any = null
    private starFilledIcon: string = `<svg width="1em" height="1em" viewBox="0 0 14 13" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 0L9.1 4.1L13.6 4.8L10.3 8L11.1 12.6L7 10.4L2.9 12.6L3.7 8L0.4 4.8L4.9 4.1L7 0Z" fill="currentColor"/>
    </svg>`
    private starEmptyIcon: string = `<svg width="1em" height="1em" viewBox="0 0 14 13" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M7 0L9.1 4.1L13.6 4.8L10.3 8L11.1 12.6L7 10.4L2.9 12.6L3.7 8L0.4 4.8L4.9 4.1L7 0Z" stroke="currentColor"/>
    </svg>`

    constructor() {
        super()

        this.className = 'embla__slide md:flex-[0_0_calc(50%-5px)] lg:flex-[0_0_calc(25%-15px)] flex-[0_0_calc(100%-0px)] min-w-[0]'
    }

    /**
     * Set the review data and render the component
     * @param data The review data from Klaviyo
     */
    setReviewData(data: any) {
        this.reviewData = data
        this.render()
    }

    /**
     * Generate star rating HTML based on the rating value
     * @param rating The rating value (1-5)
     * @returns HTML string with star icons
     */
    private generateStarRating(rating: number): string {
        let starsHtml = ''
        for (let i = 1; i <= 5; i++) {
            if (i <= rating) {
                starsHtml += this.starFilledIcon
            } else {
                starsHtml += this.starEmptyIcon
            }
        }
        return starsHtml
    }

    /**
     * Render the review item with the same styling as the Shopify snippet
     */
    private render() {
        if (!this.reviewData) return

        // Extract review data
        const reviewerName = this.reviewData.name || ''
        const rating = this.reviewData.rating || 5
        const reviewTitle = this.reviewData.title || ''
        const reviewDescription = this.reviewData.description || ''

        // Create the HTML structure
        this.innerHTML = `
            <div class="">
                <div class="flex flex-col mb-4">
                    <p class="text-base">${reviewerName}</p>
                    <div class="text-[14px] leading-[0.95] tracking-[-0.1em] flex">
                        (${this.generateStarRating(rating)})
                    </div>
                </div>
                <h3 class="mb-4 text-base">${reviewTitle}</h3>
                <p class="text-base">${reviewDescription}</p>
            </div>
        `
    }
}

customElements.define('review-item', ReviewItem)
